export default "__VITE_ASSET__BZZOn7nB__"